<template>
  <div
    class="benefit-card"
    :class="{ 'locked': isLocked }"
    @click="$emit('select', benefit)"
    role="button"
    tabindex="0"
    @keydown.enter.space.prevent="$emit('select', benefit)"
    :aria-label="`${benefitTitle}, ${benefitLocation}`"
  >
    <div class="benefit-card__icon" :class="{ 'locked': isLocked }">
      <span
        class="benefit-card__icon-mask"
        :class="{ 'locked': isLocked }"
        :style="{
          WebkitMaskImage: `url(${benefitIcon})`,
          maskImage: `url(${benefitIcon})`
        }"
        :aria-label="isLocked ? 'Locked benefit' : 'Available benefit'"
      ></span>
    </div>

    <div class="benefit-card__info">
      <span class="benefit-card__name" :title="benefitTitle">{{ benefitTitle }}</span>
      <span class="benefit-card__location">{{ benefitLocation }}</span>
    </div>

    <div class="benefit-card__arrow">
      <img src="/img/member-icon/arrow-right.svg" alt="" aria-hidden="true">
    </div>
  </div>
</template>

<script>
export default {
  name: 'BenefitCard',
  emits: ['select'],
  props: {
    benefit: {
      type: Object,
      required: true,
      default: () => ({})
    },
    isLocked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    benefitTitle() {
      return this.benefit?.name || 'Member Benefit';
    },
    benefitLocation() {
      return this.benefit?.merchant?.name
        || this.benefit?.branch?.name
        || this.benefit?.corporate?.name
        || '—';
    },
    benefitIcon() {
      return this.isLocked
        ? '/img/member-icon/locked-icon.svg'
        : '/img/member-icon/checklist.svg';
    }
  }
}
</script>

<style scoped>
.benefit-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #FAFAFA;
  border-radius: 10px;
  border: 1px solid #EBEBEB;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  text-align: left;
  overflow: hidden;
}

.benefit-card:hover {
  background: white;
  border-color: var(--primary-border, #F93E3E);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.benefit-card:focus-visible {
  outline: 2px solid var(--primary-color, #F93E3E);
  outline-offset: 2px;
}

.benefit-card.locked {
  opacity: 0.65;
}

.benefit-card.locked:hover {
  border-color: #D1D5DB;
  box-shadow: none;
}

/* Icon */
.benefit-card__icon {
  width: 40px;
  min-width: 40px;
  height: 40px;
  background-color: white;
  border-radius: 50%;
  border: 1px solid #E1E4EA;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.benefit-card__icon.locked {
  background-color: #F5F5F5;
  border-color: #D1D5DB;
}

.benefit-card__icon-mask {
  display: inline-block;
  width: 55%;
  height: 55%;
  background-color: var(--primary-color, #00AA00);
  -webkit-mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
}

.benefit-card__icon-mask.locked {
  background-color: #9CA3AF;
}

/* Info */
.benefit-card__info {
  flex: 1;
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3px;
  overflow: hidden;
}

.benefit-card__name {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 100%;
}

.benefit-card__location {
  font-size: 11px;
  color: #717784;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 100%;
}

/* Arrow */
.benefit-card__arrow {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  opacity: 0.4;
}

.benefit-card__arrow img {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
